import { useMemo } from "react";

export interface Edge<NodeT> {
  node: NodeT | null;
}
export interface Connection<EdgeT> {
  readonly totalCount?: number;
  readonly edges: ReadonlyArray<EdgeT | null>;
}

export type NullableConnection<T> = Connection<T> | null;

export type ConnectionEdgeType<
  ConnectionT extends Connection<Edge<Record<string, unknown>>> | null,
> = NonNullable<NonNullable<ConnectionT>["edges"][0]>;

export type ConnectionNodeType<
  ConnectionT extends Connection<Edge<Record<string, unknown>>> | null,
> = NonNullable<ConnectionEdgeType<ConnectionT>["node"]>;

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export const getConnectionNodes = <NodeT>(connection?: Connection<Edge<NodeT>> | null) => {
  return connection?.edges?.map(edge => edge?.node).filter(notEmpty) || [];
};

export const useConnectionNodes = <NodeT>(connection?: Connection<Edge<NodeT>> | null) => {
  return useMemo(() => getConnectionNodes(connection), [connection]);
};

export const useNodesFromEdges = <NodeT>(edges: Edge<NodeT>[]) => {
  return useMemo(() => edges.map(edge => edge?.node).filter(notEmpty), [edges]);
};
